// Commenting code as requested by BA - donoor for  Ticket - 7105, Developer - Yash S
export const warningPopResponse = {
    'SAVE_AND_CONTINUE': 1,
    'YES': 2,
    'NO': 3,
    'OK': 4,
    'CANCEL': 5  
    // 'CREATE_FEE_REVERSAL': 5
}

export const invoiceTemplate = {
  'CREATE_TEMPLATE': 'CREATE_TEMPLATE'
}

export const TaskType = {
    TaskGroup: 1,
    Task: 2,
    SubTask: 3
}

export const ColumnNames = {
    Name: 0,
    Type: 1,
    Date: 2,
    Assignee: 3,
    Status: 4,
    Unit: 5,
    Role:6,
    Estimate: 7,
    startDate:8,
    dueDate:9,
    refreshData:10
}

export const TaskEvents = {
    'TOGGLE_ACCORDIAN': 'TOGGLE_ACCORDIAN',
    'ADD_NEW_RECORD': 'ADD_NEW_RECORD',
    'DELETE_RECORD': 'DELETE_RECORD',
    'UPDATE_STATUS': 'UPDATE_STATUS',
    'UPDATE_ASSIGNEE': 'UPDATE_ASSIGNEE',
    'UPDATE_ROLE': 'UPDATE_ROLE',
    'UPDATE_TASK_TYPE': 'UPDATE_TASK_TYPE',
    'BULK_UPDATE': 'BULK_UPDATE',
    'ADD_MULTIPLE_TASKS': 'ADD_MULTIPLE_TASKS',
    'ADD_MULTIPLE_TASKS_SETTINGS': 'ADD_MULTIPLE_TASKS_SETTINGS'
}

export const CommonEvents = {
    'TIMESHEET_UPDATE': 'TIMESHEET_UPDATE',
    'TIMELOG_UPDATE' : 'TIMELOG_UPDATE',
    'CLIENTNAME_UPDATE' : 'CLIENTNAME_UPDATE'
}
export const DateFormats = {
  'SHORT_DATE': 'dd/MM/yyyy',
  'LONG_DATE_12hr': 'dd/MM/yyyy hh:mm a',
  'LONG_DATE_24hr': 'dd/MM/yyyy HH:mm',
  'SDate_placeholdertxt': 'dd/mm/yyyy'
}

export const FeatureFlags = {
    WorkflowList: 'showworkflow',
    ClientList: 'showclientslist',
    SettingList: 'showsettingslist',
    Timesheet: 'showtimesheet',
    JobRecurrence: 'showreccurencejobs',
    ShowNIConnection: 'showniconnection',
    ShowXeroConnection: 'showxeroconnection',
    ShowXeroBlueConnection: 'showxeroblueconnection',
    ShowFuseSignConnection: 'showfusesignconnection',
    ShowATO: 'showato',
    ShowTeams: 'showteams',
    ShowCAS360: 'showcas360',
    ShowNewBilling: 'showWIP',
    ShowPushToXeroBlue: 'showpushtoxeroblue',
    ShowBusinessFitness: 'showbusinessfitness',
    WorkflowListBeta: 'showworkflowbeta',
    ShowGovReports: 'showgovreports',
    ShowClass: 'showclass',
    ShowAgedWIPReport: 'showagedwipreport',
    ShowInvoiceApproval: 'showinvoiceapproval',
    ShowGenerateAgedDebtorReport: 'showgenerateageddebtorreport',
    ShowProcessAutomation: 'showprocessautomation',
    ShowAutoReconcile: 'showautoreconcile',
    ShowRequestFiles:"showrequestfiles",
    ShowSyncToOneDrive:"showsynctoonedrive",
    ShowClientClassic: 'showclientclassic',
    ShowBillingBeta: 'showbillingbeta',
    ShowInvoiceAllocation: "showinvoiceallocation",
    showBglConnection: "showbglconnection",
    ShowBulkGenerateInvocie: "showBulkGenerateInvocie",
    ShowInvoiceAllocationFlow2: "showinvoiceallocationflow2",
    ShowIncludeZeroWIP: "showincludezerowip",
    EnableWIPLock: "enablewiplock",
    ShowInternalUsers: "showinternalusers",
    ShowInvoiceNarration: "showinvoicenarration",
    ShowStaffEfficeincyReport: "showstaffefficeincyreport"
}

export const Profiles = {
    'CREATE_EDIT_INFINITY': 'CREATE_EDIT_INFINITY',
    'CREATE_ADD_DELETE_INFINITY': 'CREATE_ADD_DELETE_INFINITY',
    'CREATE_EDIT_XEROBLUE': 'CREATE_EDIT_XEROBLUE',
    'CREATE_EDIT_FUSESIGN': 'CREATE_EDIT_FUSESIGN',
    'CREATE_EDIT_ANNATURE': 'CREATE_EDIT_ANNATURE',
    'CREATE_EDIT_CAS360': 'CREATE_EDIT_CAS360',
    'CREATE_EDIT_MSO365': 'CREATE_EDIT_MSO365'
}
export const FileSizeLimit = {
    Max: 500,
    Min: 1
}
export const SFGridFilteredOperators = {
    stringOperator: [
        { value: 'contains', text: 'Contains - and' },
        { value: 'contains_or', text: 'Contains - or' }, /* this is a custom operator */
        { value: 'equal', text: 'Equal' },
        { value: 'notequal', text: 'Not equal' },
        { value: 'isempty', text: 'Is empty' },
        { value: 'isnotempty', text: 'Is not empty' },
    ],
}
export const invoiceFlowStatus = {
    Publish: 1,
    PublishAndApprove: 2,
    PublishApproveAndSend: 3,
    PublishAndReview: 4,
    Review: 5,
    ReviewAndApprove: 6,
    ReviewApproveAndSend: 7,
    Approve: 8,
    ApproveAndSend: 9
};

export enum WorkFlowTabs {
    Jobs = "Jobs",
    Tasks = "Tasks",
    Planned = "Planned",
    TaxLodgement = "Tax"
}

export enum ClientTabs {
    Client = "client",
    Groups = "groups",
    Contacts = "contacts",
    ClientClassic = "clientClassic"
}
